import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// icons
import CheckmarkWithBorder from '@nmx/template/dist/componentLibrary/foundations/Icon/icons/illustrative/lightTheme/CheckmarkWithBorder';
// styles
import {
  DivStyled,
  TypographyStyled,
} from './styles';

export default () => {
  return (
    <SectionContainer
      id='fafa-page-advisor-match-checklist'
      className='js-hide-on-submit'
      backgroundVariant='lightA'
      themeType='lightTheme'>
      <Row align='center'>
        <Col
          small={10}
          medium={12}>
          <Typography
            component='h2'
            align='center'
            nextElement='graphic'>
            How we make sure your advisor is a good match:
          </Typography>
        </Col>
      </Row>
      <Row align='center'>
        <Col
          small={10}
          medium={4}>
          <Row>
            <Col
              xsmall={3}
              small={2}
              medium={3}>
              <DivStyled>
                <CheckmarkWithBorder />
              </DivStyled>
            </Col>
            <Col
              xsmall={9}
              small={10}
              medium={9}>
              <TypographyStyled>
                They have the right expertise for your goals
              </TypographyStyled>
            </Col>
          </Row>
        </Col>
        <Col
          small={10}
          medium={4}>
          <Row>
            <Col
              xsmall={3}
              small={2}
              medium={3}>
              <DivStyled>
                <CheckmarkWithBorder />
              </DivStyled>
            </Col>
            <Col
              xsmall={9}
              small={10}
              medium={9}>
              <TypographyStyled>
                They work with other people like you
              </TypographyStyled>
            </Col>
          </Row>
        </Col>
        <Col
          small={10}
          medium={4}>
          <Row>
            <Col
              xsmall={3}
              small={2}
              medium={3}>
              <DivStyled>
                <CheckmarkWithBorder />
              </DivStyled>
            </Col>
            <Col
              xsmall={9}
              small={10}
              medium={9}>
              <TypographyStyled disableBottomPadding>
                They understand the area where you live
              </TypographyStyled>
            </Col>
          </Row>
        </Col>
      </Row>
    </SectionContainer>
  );
};
